import React from "react"
import AddItemdetails from "./AdhocMatrialLines" // import row item details 
import DatePicker from "../forms/DatePicker" // import DatePicker 
import axios from 'axios';
import Navbar from '../Navbar';
import { format } from 'date-fns';
import swal from 'sweetalert';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Link, useNavigate,useParams } from 'react-router-dom';
import {
    createTheme,
    PaletteColorOptions,
    ThemeProvider,
  } from '@mui/material/styles';
  import { Stack } from '@mui/material';

class AdhocMatrial extends React.Component {

    // state define 
    constructor(props) {
        super(props)
        this.state = {
            addMore: [{ index: Math.random(), sr: "", HSN: "", certificate_id:"" ,Chapt: "", Mat: "",rate:"", QTY: "",AMT: ""}],//item list
            month_of_test:localStorage.getItem("monthOfTest"),
            party_code: "",
            email:"",
            address: "",
            gstno:"",
            user_id:localStorage.getItem("auth_id"),
            posts:[],
            error_list: [],
            enddate:"",
            selectedGSTRate: "18", // Default selected GST rate is 18%
            popupdata:"",
            dateError:""

        };
    }

    // get party all code 
    componentDidMount(){
        //api call
        fetch('https://cert.geekay.biz/backend/api/view-customer').then(resp=>resp.json()) //production
        // fetch('/api/view-customer').then(resp=>resp.json()) //local
        .then(resp=>this.setState({posts:resp.customer}))
    }

    validateForm = () => {
        // Add your validation logic here
        const { addMore, month_of_test, party_code, email, address, gstno } = this.state;
        const errors = {};
    
        // Example validation (you should customize this based on your requirements)
        if (!month_of_test) {
            errors.month_of_test = "Month of Test is required";
        }
    
        if (!party_code) {
            errors.party_code = "Party Code is required";
        }

        if (this.state.dateError!="") {
            console.log('Error',this.state.popupdata)
            errors.dateError = "Please select date in correct format"
            this.setState({dateError:""});
        }
    
        // Validate addMore fields
           
        this.setState({ error_list: errors });
    
        return Object.keys(errors).length === 0;
    };
    // handle input changes
    handleChange = (e) => {
        if (["sr", "HSN","certificate_id" ,"Chapt", "Mat", "QTY","rate", "AMT"].includes(e.target.name)) {
            console.log('inside handel change',this.state)
            let addMore = [...this.state.addMore]
            const index = e.target.dataset.id;

            if (["QTY", "rate"].includes(e.target.name)) {
                addMore[index][e.target.name] = parseFloat(e.target.value) || 0;
            } else {
                addMore[index][e.target.name] = e.target.value;
            }
    
            if (!isNaN(addMore[index].QTY) && !isNaN(addMore[index].rate)) {
                addMore[index].AMT = (addMore[index].QTY * addMore[index].rate).toFixed(2);
            }
            
            this.setState({ addMore });
    
            addMore[e.target.dataset.id][e.target.name] = e.target.value;
        } else {
            this.setState({ [e.target.name]: e.target.value })
        }
    }

    // handle input changes
    handleChangeDate = (e) => {

        var dateToday = new Date();
        // console.log(dateToday)
    }

    // party name , associate_code, and Address populate using party code 
    handlePartyCode = (e) => {
        const partyCode = e.target.value;
        axios.get(`/api/party_name/${partyCode}`).then(res=>{
            if(res.data.status===200){
                // console.log(res.data.customer[0])
                
                let address= res.data.customer[0].address;
                let gstno= res.data.customer[0].gstno;
                let email= res.data.customer[0].email;
                this.setState({address:address})
                this.setState({gstno:gstno})
                this.setState({email:email})
                document.getElementById("address").value = address;
                document.getElementById("gstno").value = gstno;
                document.getElementById("email").value = email;

                
            }
            
            });
    }

    handleGSTCheckbox = (rate) => {
        this.setState({ selectedGSTRate: rate });
        
    }

    
    //  Add new row Item details
    addNewRow = () => {
        this.setState((prevState) => ({
            addMore: [...prevState.addMore, { index: Math.random(),sr: "", HSN: "", Chapt: "", Mat: "", cd:"" ,QTY: "", AMT: ""}],
        }));
    }

    handleinvoiceDate = (e) => {
        // setPopupdata(e.target.value);
        this.setState({popupdata:e.target.value});
        var check = e.target.value.split("-");
        var monthOfTest = this.state.month_of_test.split("-");
        var month = monthOfTest[0]
        var year = monthOfTest[1]
        var popupyear = check[0];
        var poppmonth = check[1];
        var today = new Date(e.target.value);
        var popupmonth = today.toLocaleString("default", { month: "short" });
        if (popupmonth !== month || popupyear !== year) {
            // console.log('date')
          this.setState({dateError:"Please select date within the Certificate Date"});
        }
        else {
            var popupdata = e.target.value;
          axios.post(`api/check_date`,{popupdata}).then((res) => {
            console.log(res)
            if(res.data.status === 201){
                console.log()
                this.setState({dateError:res.data.message});
            }
            else{
                this.setState({dateError:""});
                this.setState({error_list:[this.state.error_list.dateError:""]});
                this.setState({popupdata:e.target.value});
            }
          });
          
          
        }

    };

    datepicker = () => {
        //  var check = popupdata.split("-");
        //  var popupyear = check[0];
        // // var month = check[1];
        // var today = new Date(popupdata);
        // var popupmonth = today.toLocaleString("default", { month: "short" });
        // if (popupmonth !== month || popupyear !== year) {
        //   setErrorMessage("Please select date within the Certificate Date");
        // }
        this.setState({date:""});


        console.log('this')
    }
    
    handleSubmit = (e) => {
        console.log(this.state)
        e.preventDefault();
        if (this.validateForm()) {
       // console.log("handleSubmit is called!");
        let data = {
            ...this.state,
            gst_rate: this.state.selectedGSTRate,
        };
    
        //console.log('Sarfraj check call handel submit buton',data);  
        console.log('Data to be submitted:', data); // Log data to console

        axios.post('api/adhoc_matrial',data).then(res =>{
            console.log(res.data)
            console.log(res.data.status)
            console.log('diifrent',res.data['status'])
            if(res.data.status===200){
                swal(
                  "Success",
                  res.data.message || "Matrial Invoice Generated!",
                  "success"
                );
                document.getElementById('Adhoc_Matrial').reset();
                window.location.href = '/certificates/showinvoices';
            }
            else if(res.data.status===400){
                this.setState({...this.state, error_list:res.data.errors});
            }
            })

        .catch(error => {
            console.error("Error:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
            }
        });
        

    }
    
    };    
    //  delete addMore detals Row
    clickOnDelete(record) {
        this.setState({
            addMore: this.state.addMore.filter(r => r !== record)
        });
    }

    // create form field data 
    render() {
        let { addMore } = this.state //collected data add more all field 
        return (
            <div className="content">
            <Navbar />
                <NotificationContainer />
                <form id= "Adhoc_Matrial" onSubmit={this.handleSubmit} onChange={this.handleChange} >
                    <div className="row" style={{ marginTop: 50, marginLeft:"50px",marginRight:"50px",paddingLeft:"70px",paddingRight:"70px" }}>
                         <div className="col-sm-1"></div>
                        <div className="col-sm-12" >
                            <div className="card">
                                <div className="card-header"><h4><b>Adhoc Matrial Billing</b></h4>
                                 </div>
                                <div className="card-body">
                                    <div className="row">

                                    <section>


                                    <div style={{ marginLeft:"15", }}>
                                             <h4 style={{marginLeft:5, marginTop:-15}}>  GEEKAY INDUSTRIES INDIA</h4>
                                            </div> 

                                        

                                            <div style={{width:"35%" , marginTop:-5}}>
                                                <p style={{fontSize:"15px", marginLeft:3}}>
                                                   17A, Sitafalwadi, Mount Road, Mazgaon 400 010
                                                </p>
                                            </div>
                                       

                                    <div className="col-sm-4" style={{ marginBottom: "15px", marginLeft:720,width:80,marginTop:-63 }}>
                                            <div className="form-group ">
                                                <select name="party_code" id="party_code" className="form-control" onChange={this.handlePartyCode}>
                                                    <option value="">-- Party Code --</option>
                                                    {this.state.posts.map(post=><option key={post.pcode}>{post.pcode}{post.title}</option>)}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.party_code}</span>
                                            </div>
                                        </div>
                                         
                                            <div style={{marginLeft:840, marginTop:-52}}>
                                                <h5 style={{fontSize:"17px"}}>GSTIN:27AAQPA2952B1Z0
                                                   </h5>
                                            </div>
                                            
                                            <div style={{marginLeft:810,marginTop:2 }}>
                                            <h6 style={{fontSize:"13px"}}>
                                            STATE OF SUPPLY: MAHARASHTRA - 27
                                             </h6>   
          
                                            </div>

                                            <div style={{marginLeft:810,marginTop:3 }}>
                                            <h6 style={{fontSize:"13px"}}>
                                            GST Rate:
                                            <input type="checkbox" id="originalCheckbox"
                                             style={{ marginLeft: 5 }}
                                             checked={this.state.selectedGSTRate === "18"}  
                                             onChange={() => this.handleGSTCheckbox("18")} />
                                             <label htmlFor="originalCheckbox" style={{ fontSize: "14px", marginLeft: 1 }}>
                                                 18%
                                            </label>
                                            <input type="checkbox"  id="checkbox12"
                                              style={{ marginLeft: 5 }}
                                              checked={this.state.selectedGSTRate === "12"}  
                                              onChange={() => this.handleGSTCheckbox("12")}/>
                                              <label htmlFor="originalCheckbox" style={{ fontSize: "14px", marginLeft: 1 }}>
                                                 12%
                                            </label>
                                            
                                             </h6>  
                                            </div>
                                            
                                            <div style={{marginLeft:380, marginTop:2}}>
                                                <p style={{fontSize:"12px"}}> Email : info@geekaygroup.com : Website : www.geekaygroup.com</p>
                                            </div>
                                            <div style={{marginRight:80, marginLeft:500}}>
                                                <h5>TAX INVOICE</h5>
                                            </div>

                                           <div style={{marginLeft:948, marginTop:-30, marginRight:1}}>
                                             <input type="checkbox" id="originalCheckbox" />
                                             <label htmlFor="originalCheckbox" style={{ fontSize: "14px", marginLeft: 5 }}>
                                                 ORIGINAL
                                            </label>
                                           </div>

                                          <div style={{marginLeft:950, marginTop:-8}}>
                                           <input type="checkbox" id="duplicateCheckbox" />
                                           <label htmlFor="duplicateCheckbox" style={{ fontSize: "14px", marginLeft: 5 }}>
                                           DUPLICATE
                                          </label>
                                        </div>
                                        <div style={{marginLeft:950, marginTop:-5}}>
                                          <input type="checkbox" id="triplicateCheckbox" />
                                           <label htmlFor="triplicateCheckbox" style={{ fontSize: "14px", marginLeft: 5 }}>
                                               TRIPLICATE
                                           </label>
                                        </div>  
                                            
                                             <div  style={{ marginBottom: "15px" ,marginLeft:515,  marginTop:-5, width:"150px" }}>
                                             <label style={{marginLeft:-1,marginTop:-4,width:"100px"}}>GST NO.</label>
                                            <div >
                                                
                                                <input type="text"  name="gstno" id="gstno"  className="form-control" placeholder="GSTNO." />
                                                <span style={{color: "red"}} >{this.state.error_list.gstno}</span>
                                            </div>
                                        </div>
                                       < div style={{marginLeft:60, marginTop:6}}>                                 
                                           <label style={{marginLeft:455,marginTop:1,marginBottom:2,width:"100px"}}>Email</label>
                                           </div>
    
                                        <div  style={{ marginBottom: "15px" ,marginLeft:515,  marginTop:-5, width:"150px" }}>
                                        
                                            <div >
                                            
                                                <input type="text"  name="email" id="email"  className="form-control" placeholder="Email" />
                                                <span style={{color: "red"}} >{this.state.error_list.email}</span>
                                            </div>
                                        </div>  


                                             <div style={{marginLeft:890,marginTop:-75}}>
                                                <p style={{fontSize:"12px" , fontWeight: "bold"}}>
                                                Invoice No. : 

                                                </p>
                                             </div>

                                             
                                             <div style={{marginLeft:890,marginTop:-15}}>
                                             <p style={{fontSize:"12px", fontWeight: "bold"}}>
                                                  Date : {this.state.popupdata}                                      
                                                </p>
                                             </div>

                                             <div  className="col-sm-4" style={{  marginTop:-210 }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Month of Test</label>
                                                <input  type="text" name="month_of_test" id="month_of_test" defaultValue={this.state.month_of_test} className="form-control" placeholder="month_of_test" onChange={this.handleChange} />
                                                <span style={{ color: "red" }}>{this.state.error_list.month_of_test}</span>

                                            </div>
                                        </div>

                                             <div className="col-sm-4" style={{ marginBottom: "38px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Please Select Invoice Date</label>
                                                {/* --------------------get month  ----------------*/}
                                                <input
                                                  id="popupdata"
                                                  value={this.state.popupdata}
                                                  onChange={this.handleinvoiceDate}
                                                  name="popupdata "
                                                  type="date"
                                                  className="form-control"
                                                />
                                                <span style={{color: "red"}} >{this.state.dateError}</span>
                                                <span style={{color: "red"}} >{this.state.error_list.dateError}</span>
                                            </div>
                                        </div>

                                             <div  className="col-sm-4" style={{ marginBottom: "15px", marginTop:-40 }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Address</label>
                                                <input type="text" name="address" id="address"  className="form-control" placeholder="Address" />
                                                <span style={{color: "red"}} >{this.state.error_list.address}</span>
                                            </div>
                                        </div>
                                            </section>
                                            


                                        {/* <div className="col-sm-4">
                                            <div className="form-group ">
                                                <label className="required">Description</label>
                                                <textarea name="description"  id="description" className="form-control"></textarea>
                                            </div>
                                        </div> */}
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    <table class="table table-bordered" style={{ marginTop: "30px", height:"10px" }}>
                                        <thead>
                                            <tr>
                                                
                                                <th scope="col" style={{ width: "5%" }}>SR</th>
                                                <th scope="col" style={{ width: "10%" }}>HSN</th>
                                                <th scope="col" style={{ width: "10%" }}>Certificate Id</th>
                                                <th scope="col" style={{ width: "25%" }} >Chapter Description</th>
                                                <th scope="col" style={{ width: "25%" }} >Matrial Description</th>
                                                <th scope="col" style={{ width: "10%" }} >Rate</th>
                                                <th scope="col" style={{ width: "10%" }} >QTY</th>
                                                <th scope="col" style={{ width: "25%" }} >Amount</th>

                                                <th scope="col" style={{ width: "10%" }} >#</th>
                                                
                                            </tr>
                                        </thead>
                                    {/* -------------------- Create Add and Delete both Functions Delete row and Add row  ----------------*/}
                                        <tbody>
                                        <AddItemdetails add={this.addNewRow} delete={this.clickOnDelete.bind(this)} addMore={addMore} error_list={this.state.error_list.addMore} />

                                        </tbody>
                                    </table>
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Submit</button></div>
                            </div>
                        </div>
                         <div className="col-sm-1"></div>
                    </div>
                </form>
            </div>
        )
    }
}

export default AdhocMatrial